var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"auth flex-center-full"},[_c('auth-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }